import { render } from "./FilterUserByDistributorWilayah.vue?vue&type=template&id=166fdc08"
import script from "./FilterUserByDistributorWilayah.vue?vue&type=script&lang=js"
export * from "./FilterUserByDistributorWilayah.vue?vue&type=script&lang=js"
script.render = render

export default script